import React, { useMemo } from 'react'
import {
  StyleSheet,
  Text,
  View,
  ScrollView,
  useWindowDimensions,
  ActivityIndicator
} from 'react-native'
import RenderHtml from 'react-native-render-html'

import Card from '../../../components/shared/card/Card'
import { fontPalette } from '../../../static/styles/global'
import { useHomeStore } from '../../../stores/home'

const WelcomeFirst = () => {
  const homestore = useHomeStore()
  const { width, height } = useWindowDimensions()

  const storeName = homestore.homeData?.storeName?.trim()

  const rawInstructions =
    (typeof homestore.firsttimeData?.data === 'string'
      ? homestore.firsttimeData.data
      : homestore.firsttimeData?.data?.instructions) ||
    (typeof homestore.firsttimeData?.defaultData === 'string'
      ? homestore.firsttimeData.defaultData
      : '') ||
    ''

  const formattedHtml = useMemo(() => {
    if (!rawInstructions) return ''
    const trimmed = rawInstructions.trim()
    const hasHtmlTags = /<[a-z][\s\S]*>/i.test(trimmed)
    if (!hasHtmlTags) {
      return `<p>${trimmed.replace(/\n/g, '<br/>')}</p>`
    }
    return trimmed
  }, [rawInstructions])

  const cardWidth = Math.min(width * 0.9, 380)
  const contentWidth = Math.max(cardWidth - 40, 200)
  const maxScrollHeight = Math.min(height * 0.46, 360)

  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <Text style={styles.headerTitle}>
          Welcome{storeName ? ` to\n${storeName}!` : '!'}
        </Text>
      </View>

      {(formattedHtml || homestore.loading) && (
        <View style={[styles.cardWrapper, { width: cardWidth }]}>
          <Card style={styles.card}>
            <View style={styles.pillBadge}>
              <Text style={styles.pillBadgeText}>
                First Day Information
              </Text>
            </View>

            <View style={styles.htmlContainer}>
              {formattedHtml ? (
                <ScrollView
                  style={{ maxHeight: maxScrollHeight }}
                  showsVerticalScrollIndicator={true}
                  nestedScrollEnabled={true}
                  contentContainerStyle={styles.scrollContent}
                >
                  <RenderHtml
                    contentWidth={contentWidth}
                    source={{ html: formattedHtml }}
                    baseStyle={baseHtmlStyle}
                    tagsStyles={tagsStyles}
                    systemFonts={[
                      'BaiJamjuree_400Regular',
                      'BaiJamjuree_600SemiBold',
                      'BaiJamjuree_700Bold',
                      'System'
                    ]}
                  />
                </ScrollView>
              ) : (
                <View style={styles.loaderContainer}>
                  <ActivityIndicator size="small" color="#5492AD" />
                </View>
              )}
            </View>
          </Card>
        </View>
      )}
    </View>
  )
}

export default WelcomeFirst

const baseHtmlStyle = {
  color: '#1D1D1D',
  fontSize: 14,
  fontFamily: fontPalette.primaryRegular
}

const tagsStyles = {
  p: {
    margin: 0,
    lineHeight: 20
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingHorizontal: 16
  },
  headerContainer: {
    alignItems: 'center',
    marginBottom: 20
  },
  headerTitle: {
    fontFamily: fontPalette.primaryBold,
    fontSize: 27,
    lineHeight: 35,
    color: '#FFFFFF',
    textAlign: 'center'
  },
  cardWrapper: {
    alignItems: 'center'
  },
  card: {
    width: '100%',
    borderRadius: 14,
    overflow: 'hidden'
  },
  pillBadge: {
    backgroundColor: '#5492AD',
    alignSelf: 'center',
    alignItems: 'center',
    marginTop: -18,
    paddingVertical: 6,
    paddingHorizontal: 20,
    borderBottomEndRadius: 14,
    borderBottomLeftRadius: 14,
    marginBottom: 14
  },
  pillBadgeText: {
    color: '#FFFFFF',
    fontSize: 15,
    fontFamily: fontPalette.primaryBold,
    textAlign: 'center'
  },
  htmlContainer: {
    width: '100%'
  },
  scrollContent: {
    paddingBottom: 4
  },
  loaderContainer: {
    paddingVertical: 20,
    alignItems: 'center',
    justifyContent: 'center'
  }
})
